import {workplaceTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

export var BaggageTapeList = {
    time: null,
    list: [],
    init: function () {
        return m.request({
            method: 'GET',
            url: '/api/baggage-tape'
        }).then(function (response) {
            server.setOnline();

            BaggageTapeList.time = response.time;
            response.baggageTapes.forEach(function (item) {
                BaggageTapeList.list[item.id] = {
                    id: item.id,
                    name: item.caption
                };
            });

            loader.hide();
            storage.config = response.config;

            server.initPing();

            return response;
        }, function (response) {
            if (!response) {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

var ConveyerFlights = {
    time: null,
    list: [],
    error: '',
    init: function () {
        return m.request({
            method: 'GET',
            url: '/api/conveyer/flights'
        }).then(function (response) {
            server.setOnline();

            ConveyerFlights.time = response.time;
            ConveyerFlights.list = response.flights;

            loader.hide();
            storage.config = response.config;

            server.initPing();

            return response;
        }, function (response) {
            if (response && response.message) {
                ConveyerFlights.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export var ConveyerFlightsPage = {
    controller: function () {

        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (!localStorage.getItem('baggageTapeId')) {
            m.route('/conveyer');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.conveyer) {
            m.route('/');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = ConveyerFlights.init(true);
        BaggageTapeList.init();

        return {
            data: data
        }
    },
    view: function (ctrl) {
        return [
            m(".bg-primary", [
                m(".container.text-right[style='padding:10px;']", [
                    m("a[style='color:#fff;padding-left:7px']", {
                        onclick: function () {
                            localStorage.removeItem('baggageTapeId');
                            localStorage.removeItem('baggageTapeName');
                            m.route('/conveyer');
                        }
                    }, [
                        m.trust('&nbsp;Сменить ленту выдачи багажа')
                    ]),
                    m("a[style='color:#fff;padding-left:7px']", {
                        href: '/profile',
                        config: m.route
                    }, [
                        m("span.fa.fa-user"),
                        m.trust('&nbsp;Профиль')
                    ]),
                    isEnabledMsg() ?
                        m("a[style='color:#fff;padding-left:7px']", {
                            href: '/message',
                            config: m.route
                        }, [
                            m("span.fa", {
                                class: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o',

                            }),
                            m.trust('&nbsp;Сообщения')

                        ]) : [],
                    m("a[style='color:#fff;padding-left:7px']", {
                        href: '/logout',
                        config: m.route
                    }, [
                        m("span.fa.fa-sign-out"),
                        m.trust('&nbsp;Выйти')
                    ])
                ])
            ]),
            m("div[style='padding:3px']", [
                m(".container[style='padding:0']", [
                    m("h3.text-center[style='margin: 30px 0']", 'Выбранная лента выдачи багажа: ' + localStorage.getItem('baggageTapeName')),
                    m("h3.text-center[style='margin: 30px 0']", user.get('name'))
                ])
            ]),
            m("table.table.table-bordered.table-condensed.conveyer-flight-table", [
                m("thead", [
                    m("tr", [
                        m("th.text-center", {
                            style: 'font-size: 16px;min-width: 120px;'
                        }, "Рейс"),
                        m("th.text-center", {
                            style: 'font-size: 16px;'
                        }, "Время"),
                        m("th.text-center", {
                            style: 'font-size: 16px;'
                        }, "МС/ВС"),
                        m("th.text-center", {
                            style: 'font-size: 16px;'
                        }, "Время начала выкладки багажа"),
                        m("th.text-center", {
                            style: 'font-size: 16px;'
                        }, "Время окончания выкладки багажа"),
                    ])
                ]),
                m("tbody", [
                    ConveyerFlights.list.map(function (flight, i) {
                        return m("tr[style='position:relative']", [
                            m("td[style='padding:0']", [

                                m("a.conveyer-flight-link[style='color: #000;font-size: 15px;']", {
                                        onclick: function () {
                                            if(flight.bagWorkerFactBegin && flight.bagWorkerFactEnd) {
                                                return;
                                            }
                                            m.route('/conveyer/flights/' + flight.id + '/time');
                                        }
                                    },
                                    m("span[style='display:inline-block']",
                                        {
                                            class: flight.KODK == 'О' ? 'flight-canceled' : ''
                                        }, [
                                            m("span.block-canceled"),
                                            m('span', flight.boardNumber),
                                            m("br"),
                                            m("span[style='padding:4px;']", flight.AP_IATA),
                                            m('img', {src: "/img/arrival.png"}),
                                        ])
                                )
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", flight.time),
                                m("br"),
                                m("span", flight.date)
                            ]),
                            m("td.text-center.v-center", [
                                flight.parkingNumber != "" ? m("span.big-text", flight.parkingNumber) : '',
                                flight.parkingNumber != "" ? m("br") : '',
                                m("span.big-text", flight.typeVS)
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", flight.bagWorkerFactBegin.substring(11,16))
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", flight.bagWorkerFactEnd.substring(11,16))
                            ])
                        ])
                    })
                ])
            ])
        ];
    }
};
